// extracted by mini-css-extract-plugin
export default {"ribbon":"ribbon__KcejH"};